// src/utils/queryBuilderWeb.ts
// Client SDK query builder for browser environments

import {
  collection,
  query,
  where,
  orderBy,
  limit as limitClause,
  startAt,
  startAfter,
  endAt,
  endBefore,
  type Firestore,
  type Query,
} from 'firebase/firestore'
import type { QuerySpec } from '@/types/FirestoreQuery'

/** Build a Web v9 Query from a QuerySpec */
export function buildClientQuery<T>(db: Firestore, spec: QuerySpec<T>): Query<T> {
  const { collection: coll, wheres = [], orders = [], limit, cursors = [] } = spec

  let q = query(collection(db, coll)) as Query<T>

  for (const w of wheres) q = query(q, where(w.field, w.op, w.value))
  for (const o of orders) q = query(q, orderBy(o.field, o.dir))
  for (const c of cursors) {
    if (c.type === 'startAt') q = query(q, startAt(...c.values))
    if (c.type === 'startAfter') q = query(q, startAfter(...c.values))
    if (c.type === 'endAt') q = query(q, endAt(...c.values))
    if (c.type === 'endBefore') q = query(q, endBefore(...c.values))
  }
  if (limit) q = query(q, limitClause(limit))

  return q
}
